import React from 'react'
import { Col } from 'reactstrap'

const Business = () => {
  return (
    <div className="increase-p-font1-5">
      <h1>Business Edition</h1>
      <Col>
        <div>
          <p>Running a business is challenging enough without a bunch of employees
            off doing their own thing.
          </p>
          <p>With Prioritize.Plus, you can set the priorities for your entire business,
            and then let those priorities ripple through the organization like dominoes, steering and focusing each
            team
            and each individual toward the same central core values.
          </p>
          <p>Business Edition brings with it several integrations with tools
            that you already use to recording progress something that happens as your people do their jobs.
          </p>
          <div>
            <h2>How It Works</h2>
            <ul>
              <li><p>First, identify the core priorities of your business.</p></li>
              <li><p>Invite your team leads to Prioritize.Plus.</p></li>
              <li><p>Each team lead then creates one or more strategies by which their
                team will work toward each priority.
              </p>
              </li>
              <li><p>Next, invite the members of each team.</p></li>
              <li><p>Each team member then sets goals for each of their team&#39;s strategies.</p></li>
              <li><p>Finally, each team member simply journals progress as they work toward their goals.</p></li>
            </ul>
            <p>You can use any of our tool integrations to help automate logging of progress.</p>
            <p>Then you will all be able to see what is being accomplished to move toward
              the team priorities. You can <b>follow</b> progress on goals or strategies as well
              as <b>mention</b> team members while journaling.
            </p>
            <p>In addition, you can use <b>comment threads</b> to discuss and share ideas as you journal progress.</p>
            <p>As an employee&#39;s performance review approaches, the employee and the team
              lead will have a record of the work done toward the company core values. This will provide invaluable
              data
              for the review process.
            </p>
          </div>
        </div>
      </Col>
    </div>
  )
}

export default Business
